import axios from 'axios';
import { useEffect, useState } from 'react';
import url from '../../apiURL';
import {
  DescricaoDA, SectionCards
} from '../../components';
import './SobreDA.css';
import puzzle from '../assets/puzzle.svg'
import info from '../assets/info.svg'
import notebook from '../assets/notebook.svg'
import lamp from '../assets/lamp.svg'

const SobreDATEXT = [
  {
    title: 'Sobre o DA',
    text: 'O Diretório Acadêmico é a entidade de representação dos alunos matriculados nos cursos de graduação do Centro de Informática da UFPE.'
  }
];

function SobreDA() {
  const infoDA = [
    {
      title: 'Representação',
      text: 'Organizamos os alunos na defesa de seus interesses, individuais e coletivos.',
      image: puzzle
    },
    {
      title: 'Colaboração',
      text: 'Promovemos a integração e o fortalecimento das entidades de representação estudantil.',
      image: notebook
    },
    {
      title: 'Ideal',
      text: 'Lutamos pelo aperfeiçoamento da democracia para que todos gozem de liberdade, justiça e igualdade em dignidade e direitos.',
      image: lamp
    },
    {
      title: 'Diversidade',
      text: 'Observar os princípios da legalidade, impessoalidade e não fazer qualquer discriminação de raça, cor, gênero ou religião.',
      image: info
    }
  ]
  
  return (
    <div id="SobreDA">
      <SectionCards title={SobreDATEXT[0]?.title} description={SobreDATEXT[0]?.text} complement="SobreDA" />
      <div className="detailing">
        <div className="Surgimento">
          <DescricaoDA TitleDA={infoDA[0]?.title} DescriptionDA={infoDA[0]?.text} ImageDA={infoDA[0]?.image} ImageDADescription="puzzle" DAComplement="Surgimento" paragraph="Surgimento" />
        </div>
        <div className="Atualmente">
          <DescricaoDA TitleDA={infoDA[1]?.title} DescriptionDA={infoDA[1]?.text} ImageDA={infoDA[1]?.image} ImageDADescription="info" DAComplement="Atualmente" paragraph="Atualmente" />
        </div>
        <div className="Finalidade">
          <DescricaoDA TitleDA={infoDA[2]?.title} DescriptionDA={infoDA[2]?.text} ImageDA={infoDA[2]?.image} ImageDADescription="lamp" DAComplement="Finalidade" paragraph="Finalidade" />
        </div>
        <div className="Cursos">
          <DescricaoDA TitleDA={infoDA[3]?.title} DescriptionDA={infoDA[3]?.text} ImageDA={infoDA[3]?.image} ImageDADescription="notebook" DAComplement="Cursos" paragraph="Cursos" />
        </div>
      </div>
      
    </div>
  );
}

export default SobreDA;